import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SearchPromotionsPage } from './search-promotions.page';

const routes: Routes = [
  {
    path: '',
    component: SearchPromotionsPage,
    children:
    [
      {
        path: 'yoga',
        children:
        [
          {
            path: '',
            loadChildren: '../promotions-yoga/promotions-yoga.module#PromotionsYogaPageModule'
          }
        ]
      },
      {
        path: 'dance',
        children:
        [
          {
            path: '',
            loadChildren: '../promotions-dance/promotions-dance.module#PromotionsDancePageModule'
          }
        ]
      },
      {
        path: 'group-fitness',
        children:
        [
          {
            path: '',
            loadChildren: '../promotions-group-fitness/promotions-group-fitness.module#PromotionsGroupFitnessPageModule'
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchPromotionsPageRoutingModule {}
